import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ja from 'vuetify/src/locale/ja';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    
    themes: {
      light: {
      },
      
      dark: {
        primary: '#B7A142'
      }
    },
  
    options: {
      customProperties: true,
    },
  },
  lang: {
    locales: { ja },
    current: 'ja',
  },
});
